export const DEFAULT_TAG_COLOR = {
  hex: '#EA475C',
  rgb: { r: 234, g: 71, b: 92 },
};
